import React from 'react';
import ScoreSparkline from './ScoreSparkline';
import './scoreHero.css';

// The score hero panel: composite G-Score on the left, an explanation of
// where the number comes from plus a recent-assessments trend on the right.
//
// `score` is nullable — first-time users see an em dash and copy explaining
// that their first assessment sets the starting point, never a fabricated
// number.
//
// Deliberately absent: a "+N vs. baseline" delta chip and a "Baseline X, set
// <date>" line. The backend hardcodes compositeTrend/compositeDelta to
// flat/0 and the dashboard response carries no baseline value or date at
// all (see docs/g-score-api-contract.md) — rendering either would be an
// invented claim, so both are omitted entirely rather than shown as a
// neutral/zero placeholder.
export default function ScoreHero({
  score,
  lastAssessedAt,
  historyEntries,
  historyLoading,
  historyError,
  onViewHistory,
}) {
  const hasScore = score != null;

  return (
    <section className="score-hero" aria-label="G-Score summary">
      <div className="score-hero-left">
        <p className="score-hero-label">Current score</p>
        <div className={`score-hero-value${hasScore ? '' : ' is-empty'}`}>
          {hasScore ? score : '—'}
        </div>
        {hasScore ? (
          lastAssessedAt && (
            <p className="score-hero-line">
              Last assessed <strong>{formatDate(lastAssessedAt)}</strong>
            </p>
          )
        ) : (
          <p className="score-hero-line is-muted">
            Your first assessment sets your starting point.
          </p>
        )}
      </div>

      <div className="score-hero-right">
        <p className="score-hero-blurb">
          Your score comes only from assessments. Daily training keeps the routine but never
          moves this number, so a change here reflects measured performance rather than
          practice.
        </p>

        <div className="score-hero-spark">
          <p className="score-hero-label">Recent assessments</p>
          <ScoreSparkline entries={historyEntries} loading={historyLoading} error={historyError} />
        </div>

        <button type="button" className="score-hero-history-btn" onClick={onViewHistory}>
          View history
        </button>
      </div>
    </section>
  );
}

function formatDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
